import * as angular from "angular";
import {IController} from "angular";
import {PlanningDraftsService} from "../../services/planning-drafts-service.service";

export class PlanningProjectsItemListCtrl implements IController {
  projects: any
  onSelect: Function
  onDelete: Function

  public queryString?: string;
  public selectedDraft: any;
  public loading: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.selectedDraft = undefined;
    this.loading = false;
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.projects && !changes.projects.isFirstChange()){
      this.queryString = undefined;
    }
  }

  onQueryChange(queryString) {
    this.queryString = queryString;
  }


}

angular
  .module('bringoz.admin.planning')
  .component('planningProjectsItemList', {
    bindings: {
      projects: '<',
      onSelect: '&',
      onDelete: '&'
    },
    template: require('./planning-projects-item-list.html').default,
    controller: PlanningProjectsItemListCtrl
  });
